import { Box, IconButton as MuiIconButton, Paper, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { theme } from 'config/theme';
import { ReactComponent as ExpandDiagonalLineIcon } from 'assets/icons/ExpandDiagonalLineIcon.svg';
import { ReactComponent as CollapseDiagonalLineIcon } from 'assets/icons/CollapseDiagonalLineIcon.svg';
import { Dispatch, SetStateAction } from 'react';

type ToolbarProps = {
  openDashboardModal: boolean;
  setOpenDashboardModal: Dispatch<SetStateAction<boolean>>;
};

function Toolbar({ openDashboardModal, setOpenDashboardModal }: ToolbarProps) {
  return (
    <Box display="flex" alignItems="center" gap={1} ml={1} justifyContent="flex-end" p={2} mb={2}>
      <Tooltip
        placement="top"
        title={<TooltipMsg>{openDashboardModal ? 'Collapse' : 'Expand'}</TooltipMsg>}
      >
        <IconButton
          onClick={() => setOpenDashboardModal((prevState) => !prevState)}
          sx={(theme) => ({
            border: `1px solid ${theme.palette.custom.divider}`,
            ...(openDashboardModal && {
              backgroundColor: theme.palette.custom.tuna,
              color: theme.palette.custom.white,
              '&:hover': {
                color: theme.palette.custom.white,
                backgroundColor: theme.palette.custom.tuna,
              },
            }),
          })}
        >
          {openDashboardModal ? (
            <CollapseDiagonalLineIcon width={18} />
          ) : (
            <ExpandDiagonalLineIcon width={18} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
}

const IconButton = styled(MuiIconButton)(({ theme }) => ({
  borderRadius: 4,
  color: theme.palette.custom.tuna,
}));

const TooltipMsg = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontSize: 12,
  fontWeight: 600,
}));

export default Toolbar;
